import { z } from 'zod';

export const ERROR_REPORT_LIMITS = {
  message: 1000,
  stack: 4000,
  build: 64,
  route: 100,
  ua: 64,
} as const;

export const ERROR_REPORT_KINDS = ['error', 'unhandledrejection', 'console'] as const;

// z.object strips unknown keys, so a field added by a stale or hostile client never reaches the log.
export const ErrorReport = z.object({
  kind: z.enum(ERROR_REPORT_KINDS),
  message: z.string().max(ERROR_REPORT_LIMITS.message),
  stack: z.string().max(ERROR_REPORT_LIMITS.stack).optional(),
  build: z.string().max(ERROR_REPORT_LIMITS.build),
  route: z.string().max(ERROR_REPORT_LIMITS.route),
  ua: z.string().max(ERROR_REPORT_LIMITS.ua),
});

export type ErrorReport = z.infer<typeof ErrorReport>;
